var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative h-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "duration-300 delay-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isDisplayTooltip,
      expression: "isDisplayTooltip"
    }],
    class: 'bg-indigo-600 text-white tooltip-Label flex absolute rounded-lg shadow-lg text-xs z-50 py-5 px-6 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-96 ' + _vm.position,
    attrs: {
      "name": _vm.name
    },
    domProps: {
      "innerHTML": _vm._s(_vm.libelle)
    }
  })])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }